import {
  FETCH_ALL_LICENSE_PERMIT_TYPES,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSE_PERMIT_TYPES](state, licensePermitTypes) {
    state.all = licensePermitTypes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermitType/mutations.js